
import { computed, ComputedRef, defineComponent, Ref } from 'vue';
import { IonPage, IonContent, IonIcon, IonHeader, IonToolbar, IonToggle, IonTitle } from '@ionic/vue';
import { useStore, ActionTypes } from '@/store';
import User from '@/store/modules/auth/models/User';

interface Option {
  title: string
  subCategories: Array<{
    name: string
    isDangerous: boolean
    toggleValue?: boolean
    action?: () => void
  }>
}

export default defineComponent({
    name: "Settings",
    components: { IonPage, IonContent, IonIcon, IonHeader, IonToolbar, IonToggle, IonTitle },
    setup() {
        const store = useStore()
        const isLoading: ComputedRef<boolean> = computed(() => store.getters.isLoading)
        const user = computed(() => store.getters.user) as ComputedRef<User>
        const optionsList: Option[] = [
            {
                title: "Account",
                subCategories: [
                    {
                        name: "Limits and features",
                        isDangerous: false
                    },
                    {
                        name: "Native currency",
                        isDangerous: false
                    },
                    {
                        name: "Privacy",
                        isDangerous: false
                    },
                    {
                        name: "Notification settings",
                        isDangerous: false
                    },
                ]
            },
            {
                title: "Security",
                subCategories: [
                    {
                        name: "Require PIN / Biometrics",
                        isDangerous: false,
                        toggleValue: false
                    },
                    {
                        name: "Privacy mode",
                        isDangerous: false,
                        toggleValue: true
                    },
                    {
                        name: "Sign out",
                        isDangerous: true,
                        action: () => store.dispatch(ActionTypes.signUserOut),
                    }
                ]
            }
        ]

        return { isLoading, user, optionsList }
    }
})
